<template>
	<el-dialog
		:modal-append-to-body="true"
		:append-to-body="true"
		:title="$t('themelist.addMachine')"
		:visible.sync="dialogVisible"
		v-dialogDrag
		:close-on-click-modal="false"
		top="8vh"
		custom-class="cmcMachine"
		width="700px"
		@close="$emit('refresh')">
		<div :element-loading-text="$t('common.request')">
			<div class="el-search" style="border-radius: 0">
				<div class="el-right">
					<el-form :model="addMachineSearch" :inline="true" size="small" class="demo-form-inline">
						<el-form-item prop="no" style="margin-bottom: 20px; width: 140px; margin-right: 0">
							<el-input
								v-model="addMachineSearch.equipmentNo"
								:placeholder="$t('temperature.equipmentNo')"></el-input>
						</el-form-item>
						<el-form-item prop="name" style="margin-bottom: 20px; width: 140px; margin-right: 0">
							<el-input
								v-model="addMachineSearch.equipmentName"
								:placeholder="$t('temperature.equipmentName')"></el-input>
						</el-form-item>
						<el-form-item prop="name" style="margin-bottom: 20px; width: 160px; margin-right: 0">
							<el-input
								v-model="addMachineSearch.teamName"
								:placeholder="$t('machineAdvertGroup.teamName')"></el-input>
						</el-form-item>
						<el-form-item style="margin-bottom: 20px; margin-right: 0">
							<el-button type="primary" icon="el-icon-search" @click="$emit('search-add-machine')">
								{{ $t("common.search") }}
							</el-button>
							<el-button icon="el-icon-refresh" @click="$emit('reset-add-machine')">
								{{ $t("common.reset") }}
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>

			<el-table v-loading="loadingAddMachine" :data="addMachineData" border style="width: 100%">
				<el-table-column
					prop="equipmentNo"
					:label="$t('machine.equipmentNo')"
					:fixed="'left'"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="equipmentName"
					:label="$t('machine.name')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="teamName"
					:label="$t('machineAdvertGroup.teamName')"
					:align="'center'">
				</el-table-column>
				<el-table-column fixed="right" :label="$t('common.operate')" min-width="140" :align="'center'">
					<template slot-scope="scope">
						<el-button
							v-if="!scope.row.isselect"
							type="primary"
							icon="el-icon-check"
							size="mini"
							style="padding: 7px"
							@click="$emit('bind-machine', 1, scope.row.id, scope.$index)">
							{{ $t("themelist.xuanze") }}
						</el-button>
						<el-button
							v-else
							type="danger"
							icon="el-icon-close"
							size="mini"
							style="padding: 7px"
							@click="$emit('bind-machine', 0, scope.row.id, scope.$index)">
							{{ $t("themelist.quxiao") }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div v-if="addMachinePage.totalSize > 0" style="display: flow-root; margin-top: 20px">
				<el-pagination
					background
					layout="total, prev, pager, next"
					:current-page="addMachinePage.pageIndex"
					:total="addMachinePage.totalSize"
					:page-size="addMachinePage.pageSize"
					@current-change="$emit('add-machine-page-change', $event)"
					style="margin-top: 0"></el-pagination>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "ThemeAddMachineDialog",
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		loadingAddMachine: {
			type: Boolean,
			required: true,
		},
		addMachineSearch: {
			type: Object,
			required: true,
		},
		addMachineData: {
			type: Array,
			required: true,
		},
		addMachinePage: {
			type: Object,
			required: true,
		},
	},
	computed: {
		dialogVisible: {
			get() {
				return this.visible;
			},
			set(value) {
				this.$emit("update:visible", value);
			},
		},
	},
};
</script>
